<template>
  <div class="bxh">
    <div class="left col-md-8 float-left pl-0">
      <div class="comp-title ml-1">
        <div class="left">
          <h1 class="text-uppercase color-text-bold">
            <img src="../../../../static/img/comp-title.png"/>
            Bảng xếp hạng âm nhạc
          </h1>
        </div>
      </div>
      <div style="clear: both"></div>

      <div class="songpagelist mt-4">
        <div class="row mb-3" v-for="item in dataList">
          <div class="left float-left text-left">
            <a :href="prefixUrl + item.id + '/' + convertToAlias(item.song)">
              <img class="thumbnail ml-1" :src="item.thumbnail != '' ? item.thumbnail : defaultThumbnail"/>
              <h4 class="song color-text">{{ item.song }}</h4>
              <p class="singer color-text">{{ item.singer }}</p>
              <p class="songcode"><span class="color-text font-weight-bold codesong">Mã: {{ item.code }}</span></p>
            </a>
          </div>

          <div class="right float-right text-right mt-3">
            <!--<a><span class="fa fa-tablet color-text font-size-18 pl-1 pr-1"></span></a>-->
            <a @click="item.RingBackTone != '' ? showModal(downloadAlert.replace('songcode', item.RingBackTone)) : showModal(settings.installRingbacktoneAlert)">
              <span class="fa fa-download color-text font-size-18 pl-1 pr-1"></span>
            </a>
            <a @click="showModal(giftAlert.replace('songcode', item.code))">
              <span class="fa fa-gift color-text font-size-22 pl-1 pr-1"></span>
            </a>
            <a target="_blank"
               :href="shareFacebookUrl"
               class="fb-xfbml-parse-ignore"><span class="fa fa-facebook-square color-text font-size-18 pl-1 pr-1"></span></a>
          </div>
        </div>
      </div>
    </div>
    <div class="right col-md-4 float-right pr-1 pl-1">
      <most-singer></most-singer>
      <div class="ads" v-for="item in adv">
        <a :href="item.link">
          <img :src="item.image"/>
        </a>
      </div>
    </div>
    <div style="clear:both;"></div>

    <modal :modal-title="modalTitle" :modal-message="modalMessage"></modal>
  </div>
</template>

<script>
  export default {
    name: "BXH",
    data () {
      return {
        defaultThumbnail: this.settings.defaultThumbnailSong,
        prefixUrl: this.settings.prefixSong,
        adv: [],
        modalTitle: "Thông báo",
        modalMessage: "",
        shareFacebookUrl: "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href + "&amp;src=sdkpreparse",
        dataList: [
          //{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}
        ],
        giftAlert: this.settings.giftAlert,
        downloadAlert: this.settings.downloadAlert
      }
    },
    methods:{
      getListData(){
        axios.post(api.bxh)
          .then(response => {
            this.dataList = response.data.result;
          })
          .catch(e => {

          });
      },
      getListAdv(){
        this.adv = [];
        axios.post(api.adv)
          .then(response => {
            var res = response.data.result;
            res.forEach(item => {
              if(item.page == "bxh" && item.position == 1){
                this.adv.push(item);
              }
            });
          })
          .catch(e => {

          });
      },
      showModal(message){
        this.modalMessage = message;
        this.modalShow();
      }
    },
    watch: {
      "$route.path": {
        handler: function(val){
          this.getListData();
          this.getListAdv();
        },
        immediate: true
      }
    }
  }
</script>

<style scoped>
  .songpagelist .left{
    width: 65%
  }
  .songpagelist .right{
    width: 35%;
  }
  .thumbnail{
    float: left;
    margin-right: 5px;
    width: 60px;
    height: 60px;
  }
  .songcode{
    padding-left: 64px;
    position: relative;
    top: -0.8rem;
    margin-bottom: -1rem;
  }
  .codesong{
    background-color: #ececec;
    padding: 0.2rem 0.5rem;
    border-radius: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/bxh/wap/Bxh.vue